import { render } from "./dealer-news-list.vue?vue&type=template&id=c2e18786&scoped=true&ts=true"
import script from "./dealer-news-list.vue?vue&type=script&lang=ts"
export * from "./dealer-news-list.vue?vue&type=script&lang=ts"

import "./dealer-news-list.vue?vue&type=style&index=0&id=c2e18786&lang=scss&scoped=true"

import exportComponent from "/Users/panren/Desktop/太平洋网络/discount-topics-wap-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2e18786"]])

export default __exports__